import { Injectable } from '@angular/core';
import Bugsnag from '@bugsnag/js';
import { User } from "src/app/state-man/models/user.model";
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  constructor() { }

  static setUser(user: User) {
    Bugsnag.setUser(user.id.toString(), user.email, user.name);
  }

  static log(error: any) {
    if (!error) {
      error = 'General app error occurred.';
    }
    Bugsnag.notify(error);
    if(environment.env === 'development' || environment.env === 'foretest' || environment.env === 'test') {
      console.log(error);
    }
  }
}
